import { memo, type ReactNode } from 'react';

import StatusErrorIcon from '@atlaskit/icon/core/status-error';
import { Inline, Text } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { SentryErrorBoundary } from './sentry-error-boundary';

type Props = {
  children: ReactNode;
};

export const TopNavErrorBoundary = memo((props: Props) => {
  return (
    <SentryErrorBoundary
      componentId="top-nav-error-boundary"
      renderError={({ sentryEventId }) => {
        // TODO: Replace this placeholder design
        return (
          <Inline alignBlock="center" space="space.100">
            <StatusErrorIcon color={token('color.icon.danger')} label="" />
            <Text>
              Something went wrong: <code>{sentryEventId}</code>
            </Text>
          </Inline>
        );
      }}
    >
      {props.children}
    </SentryErrorBoundary>
  );
});
